<script lang="ts">
	import { Button } from '$lib/shadcn/ui/button'

	export let downloadable: boolean
	export let public_id: string
	export let category: string
	export let price: number
	export let discounted: number
</script>

<div class="flex flex-col gap-6">
	{#if downloadable}
		<div class="flex gap-2">
			<Button
				class="w-fit plausible-event-name--Download"
				href="/download/{category}/{public_id}"
				data-sveltekit-preload-data="off">Download</Button
			>
			<slot />
		</div>
	{:else}
		<div class="flex flex-col gap-3">
			{#if discounted}
				<p class="text-muted-foreground text-sm">
					On Sale <!-- TODO: Show date -->
				</p>
			{/if}
			<div class="flex gap-3 font-semibold">
				<div class="flex gap-2">
					<span class="text-4xl text-white">
						${(discounted || price) / 100}
					</span>
					{#if discounted}
						<span
							class="text-4xl text-muted-foreground line-through"
						>
							${price / 100}
						</span>
					{/if}
				</div>
				<div class="leading-tight text-muted-foreground">
					<p class="text-sm">single-user</p>
					<p class="text-xs">
						USD, <span class="font-medium">plus taxes</span>
					</p>
				</div>
			</div>
		</div>
		<Button
			class="w-fit plausible-event-name--Checkout"
			href="/checkout/{category}/{public_id}"
			data-sveltekit-preload-data="off">Buy Now</Button
		>
	{/if}
</div>
